import { transformResults } from "~/pages/StcFinderPage/transformers";
import { type TypeSTCfinderFilterResults } from "~/pages/StcFinderPage/types";
import { resolveApiUrl } from "~/utils/url/urlResolver";

function getOnlyNumbersFromZipCode(txt: string) {
  return (txt.match(/\d/g) ?? []).join("");
}

export async function getSTCfinderResults(
  country?: string,
  state?: string,
  zipCode?: string,
): Promise<TypeSTCfinderFilterResults> {
  const stateParam = state ? `&region=${state}` : "";
  const zipCodeParam = zipCode ? `&pincode=${getOnlyNumbersFromZipCode(zipCode)}` : "";
  const apiUrl = resolveApiUrl(`/stc/filter?country=${country ?? ""}${stateParam}${zipCodeParam}`);

  const response = await fetch(apiUrl, {
    method: "GET",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Error status: " + response.status + ", please try again");
  }
  const apiData = await response.json();

  return transformResults(apiData);
}
